import { CheckoutStatus as o, OrderFormat as p, CheckoutDeliveryStatus as I, TicketStatus as u, AttendeePreOrderStatus as W, PreOrderStatus as P } from "@ancon/wildcat-types";
import H from "../order/getCheckOrderItemsMappedByTicketItemStatus.mjs";
import T from "./getCheckoutItemsMappedByTicketItemStatus.mjs";
import Y from "./isWoltDeliveryInProgress.mjs";
import "../order/getCheckOrderMinimumStatusTicketItem.mjs";
import "../toString-3b91b335.mjs";
import "../isArray-0d9c7aaa.mjs";
import "../_baseIteratee-4c4d0995.mjs";
import "../_getTag-4e44633b.mjs";
import "../_baseIsEqual-12d01a44.mjs";
import "../identity-6eafe87b.mjs";
import "../order/getMultiProductSubProductsTicketItems.mjs";
var R = /* @__PURE__ */ ((e) => (e.OrderConfirmedHostWillApproveAndProcess = "orderConfirmedHostWillApproveAndProcess", e.OrderConfirmedRestaurantAdminWillAcceptSoon = "orderConfirmedRestaurantAdminWillAcceptSoon", e.YourOrderHasBeenApprovedByHost = "yourOrderHasBeenApprovedByHost", e.OrderCanceledHostWillUpdateAndProcessAgain = "orderCanceledHostWillUpdateAndProcessAgain", e.OrderCanceledYouCanManageYourOrderAgain = "orderCanceledYouCanManageYourOrderAgain", e.YourOrderIsBeingProcessed = "yourOrderIsBeingProcessed", e.YourOrderWasCancelled = "yourOrderWasCancelled", e.ProcessingPayment = "processingPayment", e.YourOrderIsBeingPrepared = "yourOrderIsBeingPrepared", e.YourOrderIsReadyToCollect = "yourOrderIsReadyToCollect", e.YourOrderIsReadyHostWillCollect = "yourOrderIsReadyHostWillCollect", e.YourOrderIsBeingDelivered = "yourOrderIsBeingDelivered", e.YourOrderIsReadyWillBringToYourTableSoon = "yourOrderIsReadyWillBringToYourTableSoon", e.YourOrderHasBeenCompleted = "yourOrderHasBeenCompleted", e.YourOrderWillArriveAtYourTable = "yourOrderWillArriveAtYourTable", e.ModifiedDeliveryStartTime = "modifiedDeliveryStartTime", e.ModifiedPickUpTime = "modifiedPickUpTime", e.YourOrderHasBeenAcceptedEstimatedDeliveryStartTime = "yourOrderHasBeenAcceptedEstimatedDeliveryStartTime", e.YourOrderIsBeingPreparedEstimatedDeliveryStartTime = "yourOrderIsBeingPreparedEstimatedDeliveryStartTime", e.YourOrderHasBeenAcceptedEstimatedTime = "yourOrderHasBeenAcceptedEstimatedTime", e.YourOrderHasBeenAcceptedPickupTime = "yourOrderHasBeenAcceptedPickupTime", e.DeliveryWasCompleted = "deliveryWasCompleted", e.OneItemIsReadyToCollect = "oneItemIsReadyToCollect", e.OneItemIsReadyHostWillCollect = "oneItemIsReadyHostWillCollect", e.MultipleItemsAreReadyToCollect = "multipleItemsAreReadyToCollect", e.MultipleItemsAreReadyHostWillCollect = "multipleItemsAreReadyHostWillCollect", e.EnjoyMealWhileOtherItemsBeingPrepared = "enjoyMealWhileOtherItemsBeingPrepared", e.ThereWasAnError = "thereWasAnError", e.YourOrderReadyToPickupFromLocker = "yourOrderReadyToPickupFromLocker", e))(R || {});
function w(e) {
  switch (e) {
    case o.Error:
      return "thereWasAnError";
    case o.Created:
    case o.Ready:
    case o.Processing:
    case o.Authorized:
      return "yourOrderIsBeingProcessed";
    case o.Canceled:
      return "yourOrderWasCancelled";
    case o.Received:
      return "processingPayment";
    default:
      return null;
  }
}
function k(e) {
  switch (e) {
    case u.Pending:
    case u.PendingAccept:
      return "yourOrderIsBeingProcessed";
    case u.Preparing:
      return "yourOrderIsBeingPrepared";
    case u.Ready:
      return "yourOrderIsReadyToCollect";
    case u.Closed:
      return "yourOrderHasBeenCompleted";
    case u.Canceled:
      return "yourOrderWasCancelled";
    default:
      throw new Error(
        `Unhandled ticket status "${e}" in getTranslationKeyByTicketStatus()`
      );
  }
}
function b(e) {
  const { isHost: t, preOrderStatus: d, preOrderAttendeeStatus: l, preOrderCancelInfo: i } = e;
  if (l === W.Confirmed)
    switch (d) {
      case P.Started: {
        const { cancelActor: a, canceledAt: r } = i ?? {};
        return !!a && !!r ? t ? "orderCanceledYouCanManageYourOrderAgain" : "orderCanceledHostWillUpdateAndProcessAgain" : "orderConfirmedHostWillApproveAndProcess";
      }
      case P.Waiting:
        return t ? "orderConfirmedRestaurantAdminWillAcceptSoon" : "yourOrderHasBeenApprovedByHost";
    }
  return null;
}
function D(e, {
  checkoutStatus: t,
  ticketStatus: d,
  customersFetchTableOrders: l
}) {
  const i = (e == null ? void 0 : e.orderFormat) === p.Delivery, a = (e == null ? void 0 : e.orderFormat) === p.TakeAway, r = (e == null ? void 0 : e.orderFormat) === p.TableOrder;
  if (i || a || r && !l)
    return !1;
  const n = t != null, s = d != null;
  if (n) {
    const c = t === o.Captured, y = t === o.InProgress;
    return c || y;
  }
  if (s) {
    const c = d === u.Preparing, y = d === u.Ready;
    return c || y;
  }
  return !1;
}
function S(e, {
  checkoutStatus: t,
  ticketStatus: d,
  customersFetchTableOrders: l,
  pickupTimeUpdated: i,
  preOrderOptions: a
}, r) {
  const n = a && !a.isHost;
  if (r && D(e, {
    checkoutStatus: t,
    ticketStatus: d,
    customersFetchTableOrders: l
  })) {
    if (r.ready > 0)
      return r.ready < 2 ? n ? [
        "oneItemIsReadyHostWillCollect"
        /* OneItemIsReadyHostWillCollect */
      ] : [
        "oneItemIsReadyToCollect"
        /* OneItemIsReadyToCollect */
      ] : n ? r.ready === r.all ? [
        "yourOrderIsReadyHostWillCollect"
        /* YourOrderIsReadyHostWillCollect */
      ] : [
        "multipleItemsAreReadyHostWillCollect",
        { count: r.ready }
      ] : [
        "multipleItemsAreReadyToCollect",
        { count: r.ready }
      ];
    if (r.done > 0 && r.done < r.all)
      return [
        "enjoyMealWhileOtherItemsBeingPrepared",
        { count: Math.max(0, r.all - r.done - r.ready) }
      ];
  }
  if (d != null)
    return [k(d)];
  if (a && (t === o.Created || t === o.Authorized)) {
    const C = b(a);
    if (C)
      return [C];
  }
  const s = (e == null ? void 0 : e.orderFormat) === p.Delivery, c = w(t);
  if (c)
    return [c];
  const y = t === o.Captured, A = t === o.InProgress, h = t === o.Done, B = t === o.DeliveryInProgress, v = t === o.ReadyToCollect, m = (e == null ? void 0 : e.orderFormat) === p.EatIn, g = (e == null ? void 0 : e.orderFormat) === p.TakeAway, O = (e == null ? void 0 : e.orderFormat) === p.TableOrder, f = (e == null ? void 0 : e.orderFormat) === p.BoxPickup;
  if (y) {
    if (O && !l)
      return [
        "yourOrderWillArriveAtYourTable"
        /* YourOrderWillArriveAtYourTable */
      ];
    if (s)
      return i ? [
        "modifiedDeliveryStartTime"
        /* ModifiedDeliveryStartTime */
      ] : [
        "yourOrderHasBeenAcceptedEstimatedDeliveryStartTime"
        /* YourOrderHasBeenAcceptedEstimatedDeliveryStartTime */
      ];
    if (i)
      return [
        "modifiedPickUpTime"
        /* ModifiedPickUpTime */
      ];
    if (r && n && (m || g)) {
      if (r.ready === r.all)
        return [
          "yourOrderIsReadyHostWillCollect"
          /* YourOrderIsReadyHostWillCollect */
        ];
      if (r.done === r.all)
        return [
          "yourOrderHasBeenCompleted"
          /* YourOrderHasBeenCompleted */
        ];
    }
    return [
      "yourOrderHasBeenAcceptedPickupTime"
      /* YourOrderHasBeenAcceptedPickupTime */
    ];
  }
  if (A) {
    if (s)
      return i ? [
        "modifiedDeliveryStartTime"
        /* ModifiedDeliveryStartTime */
      ] : Y(e) ? [
        "yourOrderIsBeingDelivered"
        /* YourOrderIsBeingDelivered */
      ] : [
        "yourOrderIsBeingPreparedEstimatedDeliveryStartTime"
        /* YourOrderIsBeingPreparedEstimatedDeliveryStartTime */
      ];
    if (r && (m || g)) {
      if (r.ready === r.all)
        return [
          "yourOrderIsReadyToCollect"
          /* YourOrderIsReadyToCollect */
        ];
      if (r.done === r.all)
        return [
          "yourOrderHasBeenCompleted"
          /* YourOrderHasBeenCompleted */
        ];
    }
    if (O) {
      if (r) {
        if (r.ready === r.all)
          return l ? [
            "yourOrderIsReadyToCollect"
            /* YourOrderIsReadyToCollect */
          ] : [
            "yourOrderWillArriveAtYourTable"
            /* YourOrderWillArriveAtYourTable */
          ];
        if (r.done === r.all)
          return l ? [
            "yourOrderHasBeenCompleted"
            /* YourOrderHasBeenCompleted */
          ] : [
            "yourOrderWillArriveAtYourTable"
            /* YourOrderWillArriveAtYourTable */
          ];
      }
      return i ? [
        "modifiedPickUpTime"
        /* ModifiedPickUpTime */
      ] : l ? [
        "yourOrderIsBeingPrepared"
        /* YourOrderIsBeingPrepared */
      ] : [
        "yourOrderWillArriveAtYourTable"
        /* YourOrderWillArriveAtYourTable */
      ];
    }
    return i ? [
      "modifiedPickUpTime"
      /* ModifiedPickUpTime */
    ] : [
      "yourOrderIsBeingPrepared"
      /* YourOrderIsBeingPrepared */
    ];
  }
  if (h)
    return m || g ? [
      "yourOrderHasBeenCompleted"
      /* YourOrderHasBeenCompleted */
    ] : s ? [
      "deliveryWasCompleted"
      /* DeliveryWasCompleted */
    ] : [
      "yourOrderHasBeenCompleted"
      /* YourOrderHasBeenCompleted */
    ];
  if (B) {
    if (f)
      switch (e == null ? void 0 : e.deliveryStatus) {
        case I.PickedUp:
          return [
            "yourOrderHasBeenCompleted"
            /* YourOrderHasBeenCompleted */
          ];
        case I.Delivered:
          return [
            "yourOrderReadyToPickupFromLocker"
            /* YourOrderReadyToPickupFromLocker */
          ];
        default:
          return [
            "yourOrderIsBeingPrepared"
            /* YourOrderIsBeingPrepared */
          ];
      }
    if (s)
      return [
        "yourOrderIsBeingDelivered"
        /* YourOrderIsBeingDelivered */
      ];
  }
  if (v)
    return s ? [
      "yourOrderIsBeingDelivered"
      /* YourOrderIsBeingDelivered */
    ] : f ? [
      "yourOrderReadyToPickupFromLocker"
      /* YourOrderReadyToPickupFromLocker */
    ] : O && !l ? [
      "yourOrderIsReadyWillBringToYourTableSoon"
      /* YourOrderIsReadyWillBringToYourTableSoon */
    ] : r && n && (m || g) && r.done === r.all ? [
      "yourOrderHasBeenCompleted"
      /* YourOrderHasBeenCompleted */
    ] : [
      "yourOrderIsReadyToCollect"
      /* YourOrderIsReadyToCollect */
    ];
  throw new Error("Could not resolve translation key in getTranslationKey()");
}
const E = {
  orderConfirmedHostWillApproveAndProcess: () => ({
    title: `Order confirmed!
The host will approve and process the pre-order.`,
    message: "Please contact the host if you want to edit your order."
  }),
  orderConfirmedRestaurantAdminWillAcceptSoon: () => ({
    title: `Order confirmed!
The restaurant admin will accept your pre-order soon.`
  }),
  yourOrderHasBeenApprovedByHost: () => ({
    title: "Your order has been approved by host!",
    message: "The restaurant admin will accept and process the pre-order"
  }),
  orderCanceledHostWillUpdateAndProcessAgain: () => ({
    title: `Order canceled!
The host will update and process the pre-order again.`,
    message: "Please contact the host if you want to edit your order."
  }),
  orderCanceledYouCanManageYourOrderAgain: () => ({
    title: `Order canceled!
You can manage your order.`,
    message: "Please update and process the pre-order again."
  }),
  yourOrderIsBeingProcessed: () => ({
    title: "Your order is being processed"
  }),
  yourOrderWasCancelled: () => ({
    title: "Your order was canceled",
    message: "Sorry. Your order could not go through."
  }),
  processingPayment: () => ({
    title: "Processing payment",
    message: "Please wait while your payment is being processed"
  }),
  yourOrderIsBeingPrepared: () => ({
    title: "Your order is now being prepared!",
    message: "We will let you know when it is ready for pickup."
  }),
  yourOrderIsReadyToCollect: () => ({
    title: "Your order is ready to be collected!",
    message: "Please go ahead and show this screen at the collection point"
  }),
  yourOrderIsReadyHostWillCollect: () => ({
    title: "Your order is ready to be collected!",
    message: "Host will collect your order at the collection point"
  }),
  yourOrderIsBeingDelivered: () => ({
    title: "Your order is being delivered",
    message: "It will arrive at your door shortly. Enjoy your meal!"
  }),
  yourOrderIsReadyWillBringToYourTableSoon: () => ({
    title: "Your order is ready!",
    message: "Stay at your table - We will bring your order to your table soon"
  }),
  yourOrderHasBeenCompleted: () => ({
    title: "Enjoy your meal!",
    message: "Your order has been completed!"
  }),
  yourOrderWillArriveAtYourTable: () => ({
    title: "Your order has been accepted!",
    message: "It will arrive at your table shortly"
  }),
  modifiedDeliveryStartTime: () => ({
    title: "Your delivery time was modified",
    message: "Delivery will start at approximately 00:00."
  }),
  modifiedPickUpTime: () => ({
    title: "Your pickup time was modified",
    message: "Pickup time: 00:00"
  }),
  yourOrderHasBeenAcceptedEstimatedDeliveryStartTime: () => ({
    title: "Your order has been accepted",
    message: "Estimated delivery start time: 00:00"
  }),
  yourOrderIsBeingPreparedEstimatedDeliveryStartTime: () => ({
    title: "Your order is now being prepared!",
    message: "Estimated delivery start time: 00:00"
  }),
  yourOrderHasBeenAcceptedEstimatedTime: () => ({
    title: "Your order has been accepted",
    message: "Estimated time: 00:00"
  }),
  yourOrderHasBeenAcceptedPickupTime: () => ({
    title: "Your order has been accepted",
    message: "Pickup time: 00:00"
  }),
  deliveryWasCompleted: () => ({
    title: "Your order was completed",
    message: "Enjoy your meal!"
  }),
  oneItemIsReadyToCollect: () => ({
    title: "One item is ready to pick up!",
    message: "Please allow cashier or waiter to confirm that the prepared item has been successfully issued."
  }),
  oneItemIsReadyHostWillCollect: () => ({
    title: "One item is ready to pick up!",
    message: "Host will collect your order and confirm that the prepared item has been successfully issued."
  }),
  multipleItemsAreReadyToCollect: () => ({
    title: "Multiple items are ready to pick up!",
    message: "Please allow cashier or waiter to confirm that the prepared items have been successfully issued."
  }),
  multipleItemsAreReadyHostWillCollect: () => ({
    title: "Multiple items are ready to pick up!",
    message: "Host will collect your order and confirm that the prepared items have been successfully issued."
  }),
  enjoyMealWhileOtherItemsBeingPrepared: ({ meta: e }) => ({
    title: "Enjoy your meal while the rest of the items are being prepared!",
    message: `${e.count} more items are being prepared`
  }),
  thereWasAnError: () => ({
    title: "Checkout error",
    message: "There was an error with the checkout"
  }),
  yourOrderReadyToPickupFromLocker: () => ({
    title: "Your order is ready to pick up from the locker!"
  })
};
function M(e, t) {
  const i = t ? H(e) : T(e);
  return {
    all: i.all.length,
    ready: i.ready.length,
    done: i.done.length
  };
}
function V(e, t, d = E) {
  var c;
  const { isSkipTicketStatus: l, isCheckOrder: i } = t;
  let a;
  if (!l) {
    const y = (e == null ? void 0 : e.items) ?? [];
    a = M(y, !!i);
  }
  const [r, n] = S(e, t, a), s = (c = d[r]) == null ? void 0 : c.call(d, { key: r, meta: n });
  if (!s)
    throw new Error("Could not resolve translation in getOrderStatusTexts()");
  return [s, r];
}
export {
  R as TranslationKey,
  V as default
};
